import { keepPreviousData, useInfiniteQuery, useQuery } from '@tanstack/react-query'
import { useDebounce } from 'use-debounce'

import { QUERY_KEYS } from '../../../QueryKeys'
import { tasksService } from '../../tasksService'
import { TaskTemplatesFilters } from '../../types'

export const FILTER_DEBOUNCER = 500

export const useTaskTemplates = (taskTemplateFilters: TaskTemplatesFilters) => {
    const [debouncedFilters] = useDebounce(taskTemplateFilters, FILTER_DEBOUNCER)
    return useQuery({
        queryKey: [QUERY_KEYS.tasks.templates.TASK_TEMPLATES, debouncedFilters],
        queryFn: () => tasksService.getTaskTemplates(debouncedFilters),
        placeholderData: keepPreviousData,
    })
}
export const useTaskTemplatesInfinite = (taskTemplateFilters: TaskTemplatesFilters) => {
    const [debouncedFilters] = useDebounce(taskTemplateFilters, FILTER_DEBOUNCER)
    const { page, ...filtersWithoutPage } = debouncedFilters

    return useInfiniteQuery({
        queryKey: [QUERY_KEYS.tasks.templates.TASK_TEMPLATES, filtersWithoutPage],
        initialPageParam: page ?? 0,
        queryFn: ({ pageParam }) =>
            tasksService.getTaskTemplates({
                ...filtersWithoutPage,
                page: pageParam,
            }),
        getNextPageParam: currentPage => {
            const nextPage = currentPage.number + 1
            return nextPage < currentPage.totalPages ? nextPage : undefined
        },
    })
}
